import { GetCustomers, GetUsers, UpdateSearchParams, ResetAdminDashboard } from '../actions/actionTypes';
import API from '../../services/requestService';
import ENDPOINT from '../../services/endpoints';
import { showToast, showLoader } from './common';
import { TOAST_HEADER, MESSAGES } from '../../services/constants';
import { IListParams, UserTypes } from '../../shared/models/adminModels';

export const getUsers = (params: IListParams) => async (dispatch: any) => {
    dispatch(showLoader(true));
    try {
        const { data: userResponse }: any = await API.post(ENDPOINT.getUsers, params);
        dispatch(showLoader(false));
        return userResponse && userResponse.isSuccess 
        ? dispatch({
          type: GetUsers,
          payload: { ...params, ...userResponse.data } })
        :  dispatch(showToast(TOAST_HEADER.ERROR, userResponse.error));
    } catch(e) {
        console.error('getUsers', e);
        dispatch(showLoader(false));
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
        return e;
    }
}

export const getCustomers = (params: IListParams) => async (dispatch: any) => {
  dispatch(showLoader(true));
  try {
      const {data: userResponse }: any = await API.post(ENDPOINT.getCustomers, params);
      dispatch(showLoader(false));
      return userResponse.isSuccess 
        ? dispatch({
          type: GetCustomers,
          payload: { ...params, ...userResponse.data } })
        :  
          dispatch(showToast(TOAST_HEADER.ERROR, userResponse.error));
  } catch(e) {
      console.error('getCustomers', e);
      dispatch(showLoader(false));
      dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
      return e;
  }
}

export const updateSearchParams = (params: IListParams, userType: UserTypes) => (dispatch: any) => {
  dispatch({
    type: UpdateSearchParams,
    payload: { params, userType }
  });
}